
const currencies = {
    "usd": "USD",
    "$": "USD",
    "us dollar": "USD",
    "us dollars": "USD",
    "cad": "CAD",
    "ca$": "CAD",
    "canadian dollar": "CAD",
    "canadian dollars": "CAD",
    "eur": "EUR",
    "€": "EUR",
    "euro": "EUR",
    "euros": "EUR",
    "aed": "AED",
    "د.إ.‏": "AED",
    "united arab emirates dirham": "AED",
    "uae dirhams": "AED",
    "afn": "AFN",
    "af": "AFN",
    "؋": "AFN",
    "afghan afghani": "AFN",
    "afghan afghanis": "AFN",
    "all": "ALL",
    "lek": "ALL",
    "albanian lek": "ALL",
    "albanian lekë": "ALL",
    "amd": "AMD",
    "դր.": "AMD",
    "armenian dram": "AMD",
    "armenian drams": "AMD",
    "ars": "ARS",
    "ar$": "ARS",
    "argentine peso": "ARS",
    "argentine pesos": "ARS",
    "aud": "AUD",
    "au$": "AUD",
    "australian dollar": "AUD",
    "australian dollars": "AUD",
    "azn": "AZN",
    "man.": "AZN",
    "ман.": "AZN",
    "azerbaijani manat": "AZN",
    "azerbaijani manats": "AZN",
    "bam": "BAM",
    "km": "BAM",
    "bosnia-herzegovina convertible mark": "BAM",
    "bosnia-herzegovina convertible marks": "BAM",
    "bdt": "BDT",
    "tk": "BDT",
    "৳": "BDT",
    "bangladeshi taka": "BDT",
    "bangladeshi takas": "BDT",
    "bgn": "BGN",
    "лв.": "BGN",
    "bulgarian lev": "BGN",
    "bulgarian leva": "BGN",
    "bhd": "BHD",
    "bd": "BHD",
    "د.ب.‏": "BHD",
    "bahraini dinar": "BHD",
    "bahraini dinars": "BHD",
    "bif": "BIF",
    "fbu": "BIF",
    "burundian franc": "BIF",
    "burundian francs": "BIF",
    "bnd": "BND",
    "bn$": "BND",
    "brunei dollar": "BND",
    "brunei dollars": "BND",
    "bob": "BOB",
    "bs": "BOB",
    "bolivian boliviano": "BOB",
    "bolivian bolivianos": "BOB",
    "brl": "BRL",
    "r$": "BRL",
    "brazilian real": "BRL",
    "brazilian reals": "BRL",
    "bwp": "BWP",
    "p": "BWP",
    "botswanan pula": "BWP",
    "botswanan pulas": "BWP",
    "byr": "BYR",
    "belarusian ruble": "BYR",
    "belarusian rubles": "BYR",
    "bzd": "BZD",
    "bz$": "BZD",
    "belize dollar": "BZD",
    "belize dollars": "BZD",
    "cdf": "CDF",
    "frcd": "CDF",
    "congolese franc": "CDF",
    "congolese francs": "CDF",
    "chf": "CHF",
    "swiss franc": "CHF",
    "swiss francs": "CHF",
    "clp": "CLP",
    "cl$": "CLP",
    "chilean peso": "CLP",
    "chilean pesos": "CLP",
    "cny": "CNY",
    "cn¥": "CNY",
    "chinese yuan": "CNY",
    "cop": "COP",
    "co$": "COP",
    "colombian peso": "COP",
    "colombian pesos": "COP",
    "crc": "CRC",
    "₡": "CRC",
    "costa rican colón": "CRC",
    "costa rican colóns": "CRC",
    "cve": "CVE",
    "cv$": "CVE",
    "cape verdean escudo": "CVE",
    "cape verdean escudos": "CVE",
    "czk": "CZK",
    "kč": "CZK",
    "czech republic koruna": "CZK",
    "czech republic korunas": "CZK",
    "djf": "DJF",
    "fdj": "DJF",
    "djiboutian franc": "DJF",
    "djiboutian francs": "DJF",
    "dkk": "DKK",
    "dkr": "DKK",
    "kr": "SEK",
    "danish krone": "DKK",
    "danish kroner": "DKK",
    "dop": "DOP",
    "rd$": "DOP",
    "dominican peso": "DOP",
    "dominican pesos": "DOP",
    "dzd": "DZD",
    "da": "DZD",
    "د.ج.‏": "DZD",
    "algerian dinar": "DZD",
    "algerian dinars": "DZD",
    "eek": "EEK",
    "ekr": "EEK",
    "estonian kroon": "EEK",
    "estonian kroons": "EEK",
    "egp": "EGP",
    "ج.م.‏": "EGP",
    "egyptian pound": "EGP",
    "egyptian pounds": "EGP",
    "ern": "ERN",
    "nfk": "ERN",
    "eritrean nakfa": "ERN",
    "eritrean nakfas": "ERN",
    "etb": "ETB",
    "br": "ETB",
    "ethiopian birr": "ETB",
    "ethiopian birrs": "ETB",
    "gbp": "GBP",
    "£": "GBP",
    "sterling": "GBP",
    "british pound sterling": "GBP",
    "british pounds sterling": "GBP",
    "gel": "GEL",
    "georgian lari": "GEL",
    "georgian laris": "GEL",
    "ghs": "GHS",
    "gh₵": "GHS",
    "ghanaian cedi": "GHS",
    "ghanaian cedis": "GHS",
    "gnf": "GNF",
    "fg": "GNF",
    "guinean franc": "GNF",
    "guinean francs": "GNF",
    "gtq": "GTQ",
    "q": "GTQ",
    "guatemalan quetzal": "GTQ",
    "guatemalan quetzals": "GTQ",
    "hkd": "HKD",
    "hk$": "HKD",
    "hong kong dollar": "HKD",
    "hong kong dollars": "HKD",
    "hnl": "HNL",
    "l": "HNL",
    "honduran lempira": "HNL",
    "honduran lempiras": "HNL",
    "hrk": "HRK",
    "kn": "HRK",
    "croatian kuna": "HRK",
    "croatian kunas": "HRK",
    "huf": "HUF",
    "ft": "HUF",
    "hungarian forint": "HUF",
    "hungarian forints": "HUF",
    "idr": "IDR",
    "rp": "IDR",
    "indonesian rupiah": "IDR",
    "indonesian rupiahs": "IDR",
    "ils": "ILS",
    "₪": "ILS",
    "israeli new sheqel": "ILS",
    "israeli new sheqels": "ILS",
    "inr": "INR",
    "rs": "INR",
    "টকা": "INR",
    "indian rupee": "INR",
    "indian rupees": "INR",
    "iqd": "IQD",
    "د.ع.‏": "IQD",
    "iraqi dinar": "IQD",
    "iraqi dinars": "IQD",
    "irr": "IRR",
    "﷼": "IRR",
    "iranian rial": "IRR",
    "iranian rials": "IRR",
    "isk": "ISK",
    "ikr": "ISK",
    "icelandic króna": "ISK",
    "icelandic krónur": "ISK",
    "jmd": "JMD",
    "j$": "JMD",
    "jamaican dollar": "JMD",
    "jamaican dollars": "JMD",
    "jod": "JOD",
    "jd": "JOD",
    "د.أ.‏": "JOD",
    "jordanian dinar": "JOD",
    "jordanian dinars": "JOD",
    "jpy": "JPY",
    "¥": "JPY",
    "￥": "JPY",
    "japanese yen": "JPY",
    "kes": "KES",
    "ksh": "KES",
    "kenyan shilling": "KES",
    "kenyan shillings": "KES",
    "khr": "KHR",
    "៛": "KHR",
    "cambodian riel": "KHR",
    "cambodian riels": "KHR",
    "kmf": "KMF",
    "cf": "KMF",
    "fc": "KMF",
    "comorian franc": "KMF",
    "comorian francs": "KMF",
    "krw": "KRW",
    "₩": "KRW",
    "south korean won": "KRW",
    "kwd": "KWD",
    "kd": "KWD",
    "د.ك.‏": "KWD",
    "kuwaiti dinar": "KWD",
    "kuwaiti dinars": "KWD",
    "kzt": "KZT",
    "тңг.": "KZT",
    "kazakhstani tenge": "KZT",
    "kazakhstani tenges": "KZT",
    "lbp": "LBP",
    "lb£": "LBP",
    "ل.ل.‏": "LBP",
    "lebanese pound": "LBP",
    "lebanese pounds": "LBP",
    "lkr": "LKR",
    "slrs": "LKR",
    "sl re": "LKR",
    "sri lankan rupee": "LKR",
    "sri lankan rupees": "LKR",
    "ltl": "LTL",
    "lt": "LTL",
    "lithuanian litas": "LTL",
    "lithuanian litai": "LTL",
    "lvl": "LVL",
    "ls": "LVL",
    "latvian lats": "LVL",
    "latvian lati": "LVL",
    "lyd": "LYD",
    "ld": "LYD",
    "د.ل.‏": "LYD",
    "libyan dinar": "LYD",
    "libyan dinars": "LYD",
    "mad": "MAD",
    "د.م.‏": "MAD",
    "moroccan dirham": "MAD",
    "moroccan dirhams": "MAD",
    "mdl": "MDL",
    "moldovan leu": "MDL",
    "moldovan lei": "MDL",
    "mga": "MGA",
    "malagasy ariary": "MGA",
    "malagasy ariaries": "MGA",
    "mkd": "MKD",
    "macedonian denar": "MKD",
    "macedonian denari": "MKD",
    "mmk": "MMK",
    "k": "MMK",
    "myanma kyat": "MMK",
    "myanma kyats": "MMK",
    "mop": "MOP",
    "mop$": "MOP",
    "macanese pataca": "MOP",
    "macanese patacas": "MOP",
    "mur": "MUR",
    "murs": "MUR",
    "mauritian rupee": "MUR",
    "mauritian rupees": "MUR",
    "mxn": "MXN",
    "mx$": "MXN",
    "mexican peso": "MXN",
    "mexican pesos": "MXN",
    "myr": "MYR",
    "rm": "MYR",
    "malaysian ringgit": "MYR",
    "malaysian ringgits": "MYR",
    "mzn": "MZN",
    "mtn": "MZN",
    "mozambican metical": "MZN",
    "mozambican meticals": "MZN",
    "nad": "NAD",
    "n$": "NAD",
    "namibian dollar": "NAD",
    "namibian dollars": "NAD",
    "ngn": "NGN",
    "₦": "NGN",
    "nigerian naira": "NGN",
    "nigerian nairas": "NGN",
    "nio": "NIO",
    "c$": "NIO",
    "nicaraguan córdoba": "NIO",
    "nicaraguan córdobas": "NIO",
    "nok": "NOK",
    "nkr": "NOK",
    "norwegian krone": "NOK",
    "norwegian kroner": "NOK",
    "npr": "NPR",
    "nprs": "NPR",
    "नेरू": "NPR",
    "nepalese rupee": "NPR",
    "nepalese rupees": "NPR",
    "nzd": "NZD",
    "nz$": "NZD",
    "new zealand dollar": "NZD",
    "new zealand dollars": "NZD",
    "omr": "OMR",
    "ر.ع.‏": "OMR",
    "omani rial": "OMR",
    "omani rials": "OMR",
    "pab": "PAB",
    "b/.": "PAB",
    "panamanian balboa": "PAB",
    "panamanian balboas": "PAB",
    "pen": "PEN",
    "s/.": "PEN",
    "peruvian nuevo sol": "PEN",
    "peruvian nuevos soles": "PEN",
    "php": "PHP",
    "₱": "PHP",
    "philippine peso": "PHP",
    "philippine pesos": "PHP",
    "pkr": "PKR",
    "pkrs": "PKR",
    "₨": "PKR",
    "pakistani rupee": "PKR",
    "pakistani rupees": "PKR",
    "pln": "PLN",
    "zł": "PLN",
    "polish zloty": "PLN",
    "polish zlotys": "PLN",
    "pyg": "PYG",
    "₲": "PYG",
    "paraguayan guarani": "PYG",
    "paraguayan guaranis": "PYG",
    "qar": "QAR",
    "qr": "QAR",
    "ر.ق.‏": "QAR",
    "qatari rial": "QAR",
    "qatari rials": "QAR",
    "ron": "RON",
    "romanian leu": "RON",
    "romanian lei": "RON",
    "rsd": "RSD",
    "din.": "RSD",
    "дин.": "RSD",
    "serbian dinar": "RSD",
    "serbian dinars": "RSD",
    "rub": "RUB",
    "руб.": "RUB",
    "russian ruble": "RUB",
    "russian rubles": "RUB",
    "rwf": "RWF",
    "fr": "RWF",
    "rwandan franc": "RWF",
    "rwandan francs": "RWF",
    "sar": "SAR",
    "sr": "SAR",
    "ر.س.‏": "SAR",
    "saudi riyal": "SAR",
    "saudi riyals": "SAR",
    "sdg": "SDG",
    "sudanese pound": "SDG",
    "sudanese pounds": "SDG",
    "sek": "SEK",
    "skr": "SEK",
    "swedish krona": "SEK",
    "swedish kronor": "SEK",
    "sgd": "SGD",
    "s$": "SGD",
    "singapore dollar": "SGD",
    "singapore dollars": "SGD",
    "sos": "SOS",
    "ssh": "SOS",
    "somali shilling": "SOS",
    "somali shillings": "SOS",
    "syp": "SYP",
    "sy£": "SYP",
    "ل.س.‏": "SYP",
    "syrian pound": "SYP",
    "syrian pounds": "SYP",
    "thb": "THB",
    "฿": "THB",
    "thai baht": "THB",
    "tnd": "TND",
    "dt": "TND",
    "د.ت.‏": "TND",
    "tunisian dinar": "TND",
    "tunisian dinars": "TND",
    "top": "TOP",
    "t$": "TOP",
    "tongan paʻanga": "TOP",
    "try": "TRY",
    "tl": "TRY",
    "turkish lira": "TRY",
    "ttd": "TTD",
    "tt$": "TTD",
    "trinidad and tobago dollar": "TTD",
    "trinidad and tobago dollars": "TTD",
    "twd": "TWD",
    "nt$": "TWD",
    "new taiwan dollar": "TWD",
    "new taiwan dollars": "TWD",
    "tzs": "TZS",
    "tsh": "TZS",
    "tanzanian shilling": "TZS",
    "tanzanian shillings": "TZS",
    "uah": "UAH",
    "₴": "UAH",
    "ukrainian hryvnia": "UAH",
    "ukrainian hryvnias": "UAH",
    "ugx": "UGX",
    "ush": "UGX",
    "ugandan shilling": "UGX",
    "ugandan shillings": "UGX",
    "uyu": "UYU",
    "$u": "UYU",
    "uruguayan peso": "UYU",
    "uruguayan pesos": "UYU",
    "uzs": "UZS",
    "uzbekistan som": "UZS",
    "vef": "VEF",
    "bs.f.": "VEF",
    "venezuelan bolívar": "VEF",
    "venezuelan bolívars": "VEF",
    "vnd": "VND",
    "₫": "VND",
    "vietnamese dong": "VND",
    "xaf": "XAF",
    "fcfa": "XAF",
    "cfa franc beac": "XAF",
    "cfa francs beac": "XAF",
    "xof": "XOF",
    "cfa": "XOF",
    "cfa franc bceao": "XOF",
    "cfa francs bceao": "XOF",
    "yer": "YER",
    "yr": "YER",
    "ر.ي.‏": "YER",
    "yemeni rial": "YER",
    "yemeni rials": "YER",
    "zar": "ZAR",
    "r": "ZAR",
    "south african rand": "ZAR",
    "zmk": "ZMK",
    "zk": "ZMK",
    "zambian kwacha": "ZMK",
    "zambian kwachas": "ZMK"
};

export default currencies;
